import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_4,
  ANALYTICS_COLOR_5,
  ANALYTICS_COLOR_POSTS
} from '../../../config/constants';
import { displayFunctions } from '../../../utils/chartsUtils';
export const interactions = {
  addAdditionalPlots: true,
  reactions: {
    title: 'mixedChart.reactions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.sum
  },
  comments: {
    title: 'mixedChart.comments',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',
    display: displayFunctions.sum
  },

  dislikes: {
    title: 'mixedChart.dislikes',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',
    display: displayFunctions.sum
  },
  likes: {
    title: 'mixedChart.likes',
    hexColor: ANALYTICS_COLOR_4,
    type: 'line',
    display: displayFunctions.sum
  },
  shares: {
    title: 'mixedChart.shares',
    hexColor: ANALYTICS_COLOR_5,
    type: 'line',
    display: displayFunctions.sum
  }
};
export const profileAnalytics = {
  addAdditionalPlots: true,
  profile_views: {
    title: 'mixedChart.profile_views',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.sum
  },
  videos_uploaded: {
    title: 'mixedChart.videos_uploaded',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',
    display: displayFunctions.sum
  },
  videos_count: {
    title: 'mixedChart.videos_count',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',
    display: displayFunctions.sum
  }
};
export const subscribers = {
  subscribers_gained: {
    title: 'mixedChart.subscribers_gained',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',
    display: displayFunctions.sum
  },
  subscribers: {
    title: 'mixedChart.subscribers',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',
    display: displayFunctions.lastValue
  },
  subscribers_lost: {
    title: 'mixedChart.subscribers_lost',
    hexColor: ANALYTICS_COLOR_3,
    type: 'line',
    display: displayFunctions.sum
  }
};
export const newConfigsMap: any = {
  interactions,
  profile_analytics: profileAnalytics,
  subscribers,
  posts_per_day: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
  }
};
